export default __webpack_public_path__ + "static/media/hotel5.d39c0096.jpg";